import type { CampaignTaskKind } from "../types";

export type CampaignTaskMode = "distributed" | "consolidated";

export type CampaignTaskTypeConfig = {
  kind: CampaignTaskKind;
  label: string;
  mode: CampaignTaskMode;
  defaultAssignment: "related_salesperson" | "specific_user";
  metadataFields?: {
    source: string;
    label: string;
    multiline?: boolean;
  }[];
};

export const CAMPAIGN_TASK_TYPES: CampaignTaskTypeConfig[] = [
  {
    kind: "visit_demo",
    label: "Visit & demo",
    mode: "distributed",
    defaultAssignment: "related_salesperson",
    metadataFields: [
      { source: "product_to_demo", label: "Product to demo" },
    ],
  },
  {
    kind: "phone_call",
    label: "Phone call",
    mode: "distributed",
    defaultAssignment: "related_salesperson",
    metadataFields: [{ source: "talk_points", label: "Talk points", multiline: true }],
  },
  {
    kind: "send_samples",
    label: "Send samples",
    mode: "distributed",
    defaultAssignment: "related_salesperson",
    metadataFields: [
      { source: "sample_description", label: "Sample description", multiline: true },
    ],
  },
  {
    kind: "send_info",
    label: "Send product info",
    mode: "distributed",
    defaultAssignment: "related_salesperson",
    metadataFields: [
      { source: "materials", label: "Materials to send", multiline: true },
    ],
  },
  {
    kind: "meeting",
    label: "Meeting",
    mode: "distributed",
    defaultAssignment: "related_salesperson",
    metadataFields: [
      {
        source: "meeting_format",
        label: "Meeting format (in_person or online)",
      },
    ],
  },
  {
    kind: "follow_up",
    label: "Follow-up",
    mode: "distributed",
    defaultAssignment: "related_salesperson",
  },
  {
    kind: "newsletter",
    label: "Send newsletter",
    mode: "consolidated",
    defaultAssignment: "specific_user",
    metadataFields: [
      { source: "newsletter_subject", label: "Newsletter subject" },
      { source: "notes", label: "Notes", multiline: true },
    ],
  },
  {
    kind: "personal_task",
    label: "Personal task",
    mode: "consolidated",
    defaultAssignment: "specific_user",
  },
];

export const getCampaignTaskTypeConfig = (kind: CampaignTaskKind) =>
  CAMPAIGN_TASK_TYPES.find((t) => t.kind === kind);

export const isConsolidatedKind = (kind: CampaignTaskKind) =>
  getCampaignTaskTypeConfig(kind)?.mode === "consolidated";
